export default __webpack_public_path__ + "static/media/fill.e5cf5ee2.mp4";